import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEn from './locales/en/common.json';
import commonZh from './locales/zh/common.json';
import vendorEn from './locales/en/vendor.json';
import vendorZh from './locales/zh/vendor.json';
import productsEn from './locales/en/products.json';
import productsZh from './locales/zh/products.json';
import ordersEn from './locales/en/orders.json';
import ordersZh from './locales/zh/orders.json';
import inventoryEn from './locales/en/inventory.json';
import inventoryZh from './locales/zh/inventory.json';
import creatorsEn from './locales/en/creators.json';
import creatorsZh from './locales/zh/creators.json';
import forecastsEn from './locales/en/forecasts.json';
import forecastsZh from './locales/zh/forecasts.json';
import payoutsEn from './locales/en/payouts.json';
import payoutsZh from './locales/zh/payouts.json';
import adminProductsEn from './locales/en/adminProducts.json';
import adminProductsZh from './locales/zh/adminProducts.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: commonEn,
      vendor: vendorEn,
      products: productsEn,
      orders: ordersEn,
      inventory: inventoryEn,
      creators: creatorsEn,
      forecasts: forecastsEn,
      payouts: payoutsEn,
      adminProducts: adminProductsEn,
    },
    zh: {
      common: commonZh,
      vendor: vendorZh,
      products: productsZh,
      orders: ordersZh,
      inventory: inventoryZh,
      creators: creatorsZh,
      forecasts: forecastsZh,
      payouts: payoutsZh,
      adminProducts: adminProductsZh,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
